<nav class="navbar navbar-default">
    <div class="container-fluid">
        <div class="navbar-header " style=" width: 100%;">
            <button type="button" class="navbar-toggle" data-toggle="collapse" (click)="sidebarToggle()">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>
            <span class="navbar-brand">{{getTitle()}}</span>
            <div class=" navbar-brand navbar-right"> <p class="">{{user.email}}</p></div>
        </div>
        <div class="collapse navbar-collapse">
            

            <ul class="nav navbar-nav navbar-right">             
                
                <li>
                </li>
                <li class="separator hidden-lg hidden-md"></li>
            </ul>
        </div>
    </div>
</nav>
